import React, { useState, useRef, useEffect } from 'react';
import { Sparkles, Heart, Crown, Camera, Palette, Scissors, ChevronDown } from 'lucide-react';


const ServiceCategories = () => {
  const [activeCategory, setActiveCategory] = useState('bridal');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const categories = [
    {
      id: 'bridal',
      name: 'Engagement Makeup',
      icon: Heart,
      color: 'from-stone-100 to-stone-50',
      textColor: 'text-wine-dark',
      images: [
        { type: 'HD Bridal', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5ei9g3I7pboRMm1DHxtsFzBT7V348Yc9ylGfav' },
        { type: 'Traditional Bridal', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5evllWkd6fzE8OXGWyAi4wItBDlsc3ogC0pdNU' },
        { type: 'Airbrush Bridal', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5emcVQg1Sd7Mvl21e9NPJQWjqzfrVyUcAgEY4F' },
        { type: 'Destination Bridal', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eBl1qU7fPlzQToVMAKdB1ciWuta9sjJ0fHUOG' }
      ]
    },
    {
      id: 'party',
      name: 'Reception Makeup',
      icon: Sparkles,
      color: 'from-stone-100 to-stone-50',
      textColor: 'text-wine-dark',
      images: [
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5e6ZTay7Vtla42GWKYXheMgibHQdmDtIUCjcVv' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eJK3I72UyKIgi74JQqeOk1Mn2U56GwdmFcLBC' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eVFh1xObzCYFuPXoi9WQgf5l1I7eK6LD0NwZy' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5ehRWRX41TXh3qvLAOEkKP7dlzBpDbyGTmYSro' }
      ]
    },
    {
      id: 'editorial',
      name: 'Cocktail Makeup',
      icon: Camera,
      color: 'from-stone-100 to-stone-50',
      textColor: 'text-wine-dark',
      images: [
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eWQ8tTKcQpiGgVHMOmNwK8sWZYyTAlrbcoLFz' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eTQ3wT3IuiNfMvHq0g3JXwAKzEeQb7Z4t1Ssp' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5e0THheRNmk7P2xYGLgs5ETho48Awt9BOJpfQi' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5e3TOggiDdtAjBENMxY9CS7u1ePnQrGslaZ42f' }
      ]
    },
    {
      id: 'special',
      name: 'North Indian Makeup',
      icon: Crown,
      color: 'from-stone-100 to-stone-50',
      textColor: 'text-wine-dark',
      images: [
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eQMR3RaKv9ECM36AwVUYnk7KPXycj5HtW4hNa' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eR1eRJxW98Kyval0nO3L5SDMJpXE2dQNPqwhU' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5e67E2cXtla42GWKYXheMgibHQdmDtIUCjcVvw' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5egQkXBFlxnpStYgoK04emGuRBNakrUhM1v6Jj' }
      ]
    },
    {
      id: 'skincare',
      name: 'South Indian Makeup',
      icon: Palette,
      color: 'from-stone-100 to-stone-50',
      textColor: 'text-wine-dark',
      images: [
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eIH3KeWRioSXsb2TryE9fzDgaGJO8uLMpd1eU' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eTB5GzdIuiNfMvHq0g3JXwAKzEeQb7Z4t1Ssp' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5e0rETZFNmk7P2xYGLgs5ETho48Awt9BOJpfQi' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5ejKXDfkgrncFW2IwX7K105pVZTxh8kGmQCf9M' }
      ]
    },
    {
      id: 'training',
      name: 'Pakistani Makeup',
      icon: Scissors,
      color: 'from-stone-100 to-stone-50',
      textColor: 'text-wine-dark',
      images: [
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5emgH7RnvSd7Mvl21e9NPJQWjqzfrVyUcAgEY4' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eFRNgnFXS54QqMrxwlDsm6RAVi9UIdJWheuoP' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eKjSEgUFmPO5eqrXJvkZS7dhplznDamG6YfgT' },
        { type: '', image: 'https://tpdb238dk7.ufs.sh/f/Kj0hjNBmPO5eFH0BdhXS54QqMrxwlDsm6RAVi9UIdJWheuoP' }
      ]
    }
  ];

  const activeData = categories.find(cat => cat.id === activeCategory) || categories[0];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display text-black mb-6">
            Our Services
          </h2>
          <p className="text-lg text-[#622935] max-w-2xl mx-auto font-body">
            Discover our curated collection of professional makeup services tailored to your unique style.
          </p>
        </div>

        {/* Desktop Navigation - Tabs */}
        <div className="hidden lg:flex flex-nowrap overflow-x-auto justify-center gap-4 mb-12 pb-2 scrollbar-hide w-full max-w-none px-4">
          {categories.map((category) => {
            const Icon = category.icon;
            const isActive = activeCategory === category.id;
            return (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex-shrink-0 flex items-center gap-3 px-6 py-3 rounded-full transition-all duration-300 border ${
                  isActive 
                    ? 'bg-wine text-white border-wine hover:scale-105' 
                    : 'bg-white text-wine-dark border-beige-dark hover:bg-beige-light hover:border-wine'
                }`}
              >
                <Icon size={20} />
                <span className="font-display tracking-wide">{category.name}</span>
              </button>
            );
          })}
        </div>

        {/* Mobile Navigation - Dropdown */}
        <div className="lg:hidden mb-8" ref={dropdownRef}>
          <button
            type="button"
            onClick={() => setDropdownOpen((prev) => !prev)}
            className="w-full flex items-center justify-between gap-3 px-5 py-4 rounded-2xl border-2 border-beige-dark bg-white text-wine-dark font-display text-left shadow-sm hover:border-wine/50 hover:bg-stone-50/50 transition-all duration-200"
            aria-expanded={dropdownOpen}
            aria-haspopup="listbox"
            aria-label="Select service category"
          >
            <span className="flex items-center gap-3">
              {(() => {
                const Icon = activeData.icon;
                return <Icon size={22} className="text-wine flex-shrink-0" />;
              })()}
              <span className="font-display">{activeData.name}</span>
            </span>
            <ChevronDown
              size={22}
              className={`text-wine flex-shrink-0 transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}
            />
          </button>
          {dropdownOpen && (
            <ul
              className="mt-2 rounded-2xl border-2 border-beige-dark bg-white shadow-lg overflow-hidden"
              role="listbox"
              aria-label="Service categories"
            >
              {categories.map((category) => {
                const Icon = category.icon;
                const isActive = activeCategory === category.id;
                return (
                  <li key={category.id} role="option" aria-selected={isActive}>
                    <button
                      type="button"
                      onClick={() => {
                        setActiveCategory(category.id);
                        setDropdownOpen(false);
                      }}
                      className={`w-full flex items-center gap-3 px-5 py-3.5 text-left transition-colors ${
                        isActive
                          ? 'bg-wine text-white'
                          : 'text-wine-dark hover:bg-beige-light/60'
                      }`}
                    >
                      <Icon size={20} className="flex-shrink-0" />
                      <span className="font-display text-sm">{category.name}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        {/* Active Content Area */}
        <div className="animate-fade-in-up">
          <div className={`rounded-3xl p-8 bg-gradient-to-br ${activeData.color} transition-colors duration-500`}>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
              {activeData.images.map((item, index) => (
                <div 
                  key={index}
                  className="group relative aspect-[3/4] min-h-[280px] sm:min-h-[320px] overflow-hidden rounded-lg"
                >
                  <img 
                    src={item.image}
                    alt={item.type || `${activeData.name} look`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              ))}
            </div>

            
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCategories;
